import { render, staticRenderFns } from "./TqRiddleData_WarRoom.vue?vue&type=template&id=6b715aa0&scoped=true&"
import script from "./TqRiddleData_WarRoom.vue?vue&type=script&lang=js&"
export * from "./TqRiddleData_WarRoom.vue?vue&type=script&lang=js&"
import style0 from "./TqRiddleData_WarRoom.vue?vue&type=style&index=0&id=6b715aa0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b715aa0",
  null
  
)

export default component.exports